import { useState } from "react";

type Props = {
  children: React.ReactNode;
  text: string;
  number: number;
  position: { x: number; y: number };
};
export const Tooltip = ({ children, text, number, position: { x, y } }: Props) => {
  return (
    <div className="tooltip-father">
      {children}
      <div
        className={`toooltip w-50 bg-600 z-${number}  `}
        style={{
          position: "absolute",
          top: y - 20,
          left: x,
          transform: "translate(-50%, -100%)", // Centered horizontally
          borderRadius: "5px",
          padding: "1rem",
        }}
      >
        {text}
      </div>
    </div>
  );
};
